import { addDays, format, parse } from 'date-fns'

import { getUtcDate } from './getUtcDate'

type ConvertTimeOptionsBase = {
  timeStr: string | null | undefined
  baseDate?: Date
  useUtc?: boolean
  shouldReturnDefaultTime?: boolean
}
type ConvertTimeOptionsReturnDate = ConvertTimeOptionsBase & {
  shouldReturnDate?: true
}
type ConvertTimeOptionsReturnString = ConvertTimeOptionsBase & {
  shouldReturnDate: false
}

const DAY_START_TIME_STR = '00:00'

export function convertTimeStringToDate(
  options: ConvertTimeOptionsReturnDate,
): Date | undefined
export function convertTimeStringToDate(
  options: ConvertTimeOptionsReturnString,
): string | undefined
export function convertTimeStringToDate({
  timeStr,
  baseDate = new Date(),
  useUtc = false,
  shouldReturnDate = true,
  shouldReturnDefaultTime = true,
}: {
  timeStr: string | null | undefined
  baseDate?: Date
  useUtc?: boolean
  shouldReturnDate?: boolean
  shouldReturnDefaultTime?: boolean
}): Date | string | undefined {
  let effectiveTimeStr = timeStr

  if (!timeStr) {
    if (!shouldReturnDefaultTime) {
      return undefined
    }

    effectiveTimeStr = DAY_START_TIME_STR
  }

  const localDate =
    timeStr === '24:00'
      ? parse(DAY_START_TIME_STR, 'HH:mm', addDays(baseDate, 1))
      : parse(effectiveTimeStr!, 'HH:mm', baseDate)

  if (isNaN(Number(localDate))) {
    return undefined
  }

  const date = useUtc ? getUtcDate(localDate) : localDate

  if (shouldReturnDate) {
    return date
  }

  return format(date, 'HH:mm')
}
